import React from 'react';

import { careerServicesData } from '../static/data';
import Intro from '../components/Intro';
import CTA from '../components/CTA';
import Reasoning from '../components/Reasoning';
import SocialBlock from '../components/SocialBlock';
import ScrollToTop from '../components/ScrollToTop';
import SEO from '../components/SEO';
// import Button from '../components/Button';

function CareerServices() {
  let { intro, reasoning, cta } = careerServicesData;
  return (
    <>
      <SEO
        title="WE3 Academy | Career Services | Coding Bootcamp"
        description="We provide career services to all our graduates. Our team will work with you to identify your unique career goals and guide you to get your first professional role you deserve."
        keywords="WE3 Academy, WE3,  career counselor, career facilitator, career coach, career adviser, career accelerator, career counselor, career help, careers, career counselling, career guidance services, career guidance and counselling, career guidance, career support, career counsell, recruitment resource, life skill coaching, interview prep,  interview preparation, job search help, job search, job,"
        link="/career-services"
      />
      <section id="careerServices">
        <ScrollToTop />
        <Intro sectionId="howWeWorkIntro" intro={intro} />
        <Reasoning reasoning={reasoning} />
        <CTA styleType="style1" customCta={cta} />
        <SocialBlock styleType="style1" />
      </section>
    </>
  );
}

export default CareerServices;
